<template>
  <FormGroup
    :scope="scope"
    :starts-enabled="!!initialValue || null"
  >
    <template #default="{ inputName, inputId, error }">
      <select v-model="currentValue" :name="inputName" :id="inputId" class="form-select" :class="{ 'input-changed': wasChanged, 'is-invalid': error }">
        <option v-for="([optionValue, optionLabel]) in Object.entries(options)" :value="optionValue">{{ optionLabel }}</option>
      </select>
    </template>
  </FormGroup>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import type { PropType } from "@/types";
import FormGroup from "@/components/backend/candidacy/form_builder/form_items/shared/FormGroup.vue";

export default defineComponent({
  name: "SelectField",
  components: { FormGroup },
  props: {
    initialValue: {
      type: String,
      required: true
    },
    scope: {
      type: Array as PropType<string[]>,
      required: true,
    },
    options: {
      type: Object as PropType<Record<string, string>>,
      required: true
    }
  },
  data: ({ initialValue }) => ({ currentValue: initialValue }),
  computed: {
    wasChanged() {
      return this.initialValue !== this.currentValue;
    }
  },
  emits: ["update"],
  watch: {
    currentValue: {
      handler() {
        this.$emit('update', this.currentValue);
      }, deep: true,
    },
  },
});
</script>
